import React, { useState, useContext } from "react";
import injectSheet from "react-jss";
import { Tooltip, ConstrainWidth } from "folksam-ui";
import Label from "../Label";
import Errors from "../Errors";
import ImageField from "../../fields/ImageField";
import FieldWidth from "components/FieldWidth/FieldWidth";

const Context = React.createContext();

const style = {
  root: {
    /* margin: '0 0 20px 0' */
    margin: 0,
  },
};

const FieldTemplate = ({
  id,
  label,
  help,
  required,
  hidden,
  description,
  rawErrors,
  children,
  displayLabel,
  schema,
  uiSchema,
  classes,
  formContext,
  ...props
}) => {
  const [isDirty, setIsDirty] = useState(false);
  const { hasTriedSubmit } = formContext;
  const isInvalid =
    rawErrors && rawErrors.length > 0 && (isDirty || hasTriedSubmit)
      ? true
      : false;
  function handleOnBlur() {
    setIsDirty(true);
  }
  if (hidden) {
    console.warn('property "hidden" not supported');
  }

  if (schema.additionalProperties) {
    console.warn('"additionalProperties" not supported');
  }
  // All fields have support for an image
  const image = uiSchema["ui:image"];
  const hideTitle = uiSchema["ui:hideTitle"];
  // Help will be a node even though it has no content, so we need to look at the props :(
  const tooltip =
    help && help.props && help.props.help ? (
      <Tooltip>{help.props.help}</Tooltip>
    ) : undefined;
  const fieldWidth = uiSchema["ui:options"]
    ? uiSchema["ui:options"].width || "L"
    : "L";

  return (
    <ConstrainWidth>
      <div className={classes.root}>
        {hideTitle ? null : displayLabel && label ? (
          <Label id={id} tooltip={tooltip}>
            {label}
          </Label>
        ) : null}
        {displayLabel && description ? description : null}

        {image ? (
          <ImageField
            src={image.src}
            alt={image.alt}
            width={image.width + "px"}
          />
        ) : null}

        <FieldWidth constrain={fieldWidth}>
          <Context.Provider value={{ isInvalid, handleOnBlur }}>
            {children}
          </Context.Provider>
        </FieldWidth>

        {isInvalid ? <Errors>{rawErrors}</Errors> : null}
      </div>
    </ConstrainWidth>
  );
};
export const useValidity = () => {
  const state = useContext(Context);
  return state;
};
export default injectSheet(style)(FieldTemplate);
